var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgActiveIncidentsByAgeIcon = function SvgActiveIncidentsByAgeIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 100,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4111_170337)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4111_170337)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -40,
    width: 100,
    height: 100,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.5) translate(-10 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 12.6169C19.2824 12.6169 16.2568 15.6425 16.2568 19.3603C16.2568 23.0781 19.2824 26.1114 23.0002 26.1114C26.7179 26.1114 29.7435 23.0858 29.7435 19.3681C29.7435 15.6503 26.7179 12.6169 23.0002 12.6169ZM23.5835 19.1114C23.5835 19.4303 23.3191 19.6947 23.0002 19.6947C22.6813 19.6947 22.4168 19.4303 22.4168 19.1114V15.2225C22.4168 14.9036 22.6813 14.6392 23.0002 14.6392C23.3191 14.6392 23.5835 14.9036 23.5835 15.2225V19.1114Z",
    fill: "#EF5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2479 11.6833H20.7524C20.4413 11.6833 20.1924 11.4344 20.1924 11.1233C20.1924 10.8122 20.4413 10.5555 20.7524 10.5555H25.2479C25.559 10.5555 25.8079 10.8044 25.8079 11.1155C25.8079 11.4267 25.559 11.6833 25.2479 11.6833Z",
    fill: "#EF5350"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9997,
    cy: 21,
    rx: 0.666667,
    ry: 0.666667,
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4111_170337",
    x: 0,
    y: 0.5,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4111_170337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4111_170337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4111_170337"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: -40,
    width: 100,
    height: 100,
    rx: 7,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgActiveIncidentsByAgeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "active-incidents-by-age-icon.cd6a5ff1e77055ae88a7e097fa842b80.svg";